export const useResourceDefinition = () => {
  const definition = useState<string | null>('resource-definition', () => null);
  const setDefinition = (value: string | null) => {
    definition.value = value;
  };
  return { definition, setDefinition };
};
